// extracted by mini-css-extract-plugin
module.exports = {"root":"mui_select_root__32-UO","icon":"mui_select_icon__AFpIr"};